/**
 * Translations for the wallet feature area.
 */
const wallet = {
  zh: {
    'wallet.title': '💰 钱包',
    'wallet.subtitle': '看看你的每一枚金币是怎么来的',
    'wallet.balance.label': '我的金币',
    'wallet.balance.helper': '金币只用于小陪伴里的任务、储蓄和商店',
    'wallet.summary.earned': '📈 一共赚',
    'wallet.summary.spent': '📉 一共花',

    'wallet.parentVault.title': '👨‍👩‍👧 爸爸妈妈的金库',
    'wallet.parentVault.helper': '你的任务奖励会先从家长金库扣除。金库够，奖励才能马上到账。',
    'wallet.parentVault.optional': '可选',
    'wallet.parentVault.standaloneHelper': '你可以先自己玩和完成基础任务。邀请爸爸妈妈后，他们可以每天领金币、收信，也能帮你管理任务和学习计划。',
    'wallet.parentVault.inviteCta': '邀请爸爸妈妈',
    'wallet.parentVault.remindCta': '提醒爸爸妈妈领金币',
    'wallet.parentVault.reminded': '今天已经提醒过啦',

    'wallet.savings.title': '🏦 储蓄罐',
    'wallet.savings.rate.hour': '每小时 +{pct}%',
    'wallet.savings.rate.tick': '每 {hours} 小时 +{pct}%',
    'wallet.savings.rate.day': '每天 +{pct}%',
    'wallet.savings.totalInterest': '🌱 累计赚到利息 {amount}',
    'wallet.savings.deposit': '💰 存钱',
    'wallet.savings.withdraw': '🏧 取钱',
    'wallet.savings.helper.line1': '💡 把钱存进储蓄罐，<b>每 4 小时自动派利息</b>，可以在下方流水看到 🐷。',
    'wallet.savings.helper.line2': '存 💰1,000，一个月变成约 💰{m}，一年变成约 💰{y}！',

    'wallet.modal.deposit.title': '💰 存钱进储蓄罐',
    'wallet.modal.withdraw.title': '🏧 从储蓄罐取钱',
    'wallet.modal.deposit.current': '当前钱包：{amount}',
    'wallet.modal.withdraw.current': '储蓄罐里：{amount}',
    'wallet.modal.placeholder': '输入金币，例如 5 或 150',
    'wallet.modal.helper': '输入整数金币，最少 1 枚',
    'wallet.modal.deposit.cta': '存！',
    'wallet.modal.withdraw.cta': '取！',
    'wallet.modal.error.amount': '请输入正确金币数量，例如 5 或 150',
    'wallet.modal.error.amount2': '请输入正确金额',
    'wallet.toast.deposited': '存入储蓄罐 {amount} ✨',
    'wallet.toast.withdrew': '从储蓄罐取出 {amount}',

    'wallet.future.title': '🔒 以后解锁',
    'wallet.future.line1': '📈 投资 —— 让钱生钱（风险更高收益更高）',
    'wallet.future.line2': '🎯 存钱目标 —— 为心愿攒钱',
    'wallet.future.line3': '🏞️ 土地与建筑 —— 开始你的宠物乐园',

    'wallet.empty.title': '还没有金币流水',
    'wallet.empty.hint': '完成小任务或答对题目就有第一笔进账啦！',

    'wallet.source.init': '新手礼',
    'wallet.source.quiz': '答题',
    'wallet.source.chore': '小任务',
    'wallet.source.task': '任务',
    'wallet.source.parent_grant': '家长奖励',
    'wallet.source.adopt': '领养',
    'wallet.source.shop': '购物',
    'wallet.source.refund': '退款',
    'wallet.source.savings_deposit': '存入储蓄',
    'wallet.source.savings_withdraw': '取出储蓄',
    'wallet.source.savings_interest': '储蓄罐利息',
    'wallet.source.invest_buy': '买入投资',
    'wallet.source.invest_sell': '卖出投资',
    'wallet.source.challenge': '挑战',
    'wallet.source.land_buy': '买地',
    'wallet.source.building_build': '建筑',

    'wallet.error.fallback': '出错了',
  } as Record<string, string>,
  en: {
    'wallet.title': '💰 Wallet',
    'wallet.subtitle': 'See where every coin came from',
    'wallet.balance.label': 'My coins',
    'wallet.balance.helper': 'Coins are for tasks, savings, and the shop inside Xiaopeiban',
    'wallet.summary.earned': '📈 Earned',
    'wallet.summary.spent': '📉 Spent',

    'wallet.parentVault.title': "👨‍👩‍👧 Parent vault",
    'wallet.parentVault.helper': 'Your task rewards are paid from the parent vault first. If it has coins, rewards arrive right away.',
    'wallet.parentVault.optional': 'Optional',
    'wallet.parentVault.standaloneHelper': 'You can play and finish starter tasks on your own. Invite parents later so they can claim coins, read mail, and help with tasks and learning plans.',
    'wallet.parentVault.inviteCta': 'Invite parents',
    'wallet.parentVault.remindCta': 'Remind parents to claim coins',
    'wallet.parentVault.reminded': 'Already reminded today',

    'wallet.savings.title': '🏦 Piggy bank',
    'wallet.savings.rate.hour': '+{pct}% per hour',
    'wallet.savings.rate.tick': '+{pct}% every {hours} h',
    'wallet.savings.rate.day': '+{pct}% per day',
    'wallet.savings.totalInterest': '🌱 Earned {amount} in interest',
    'wallet.savings.deposit': '💰 Deposit',
    'wallet.savings.withdraw': '🏧 Withdraw',
    'wallet.savings.helper.line1': '💡 Deposit coins and the piggy bank pays <b>interest every 4 hours</b> — you can see it in the list below 🐷.',
    'wallet.savings.helper.line2': 'Deposit 💰1,000 and after a month it grows to about 💰{m}, after a year about 💰{y}!',

    'wallet.modal.deposit.title': '💰 Deposit into piggy bank',
    'wallet.modal.withdraw.title': '🏧 Withdraw from piggy bank',
    'wallet.modal.deposit.current': 'Wallet now: {amount}',
    'wallet.modal.withdraw.current': 'Piggy bank: {amount}',
    'wallet.modal.placeholder': 'Coins, e.g. 5 or 150',
    'wallet.modal.helper': 'Enter whole coins, minimum 1',
    'wallet.modal.deposit.cta': 'Deposit!',
    'wallet.modal.withdraw.cta': 'Withdraw!',
    'wallet.modal.error.amount': 'Enter a valid coin amount, e.g. 5 or 150',
    'wallet.modal.error.amount2': 'Enter a valid amount',
    'wallet.toast.deposited': 'Deposited {amount} ✨',
    'wallet.toast.withdrew': 'Withdrew {amount}',

    'wallet.future.title': '🔒 Coming later',
    'wallet.future.line1': '📈 Investing — make coins grow (higher risk, higher reward)',
    'wallet.future.line2': '🎯 Savings goals — save up for what you want',
    'wallet.future.line3': '🏞️ Land & buildings — start your pet park',

    'wallet.empty.title': 'No coin activity yet',
    'wallet.empty.hint': 'Do a small task or answer a quiz to earn your first coin!',

    'wallet.source.init': 'Welcome gift',
    'wallet.source.quiz': 'Quiz',
    'wallet.source.chore': 'Small task',
    'wallet.source.task': 'Task',
    'wallet.source.parent_grant': 'Parent gift',
    'wallet.source.adopt': 'Adopt',
    'wallet.source.shop': 'Shop',
    'wallet.source.refund': 'Refund',
    'wallet.source.savings_deposit': 'Deposit',
    'wallet.source.savings_withdraw': 'Withdraw',
    'wallet.source.savings_interest': 'Piggy interest',
    'wallet.source.invest_buy': 'Buy investment',
    'wallet.source.invest_sell': 'Sell investment',
    'wallet.source.challenge': 'Challenge',
    'wallet.source.land_buy': 'Buy land',
    'wallet.source.building_build': 'Build',

    'wallet.error.fallback': 'Something went wrong',
  } as Record<string, string>,
};

export default wallet;
